import React from 'react'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: 'brand' | 'neutral' | 'success' | 'warning' | 'danger' | 'violet'
  size?: 'xs' | 'sm'
}

const TONE = {
  brand: 'bg-brand text-brand-ink',
  neutral: 'bg-surface-2 text-ink-3 dark:bg-surface-3',
  success: 'bg-[#E8F7EA] text-[#1F8F2D] dark:bg-success/15 dark:text-success',
  warning: 'bg-[#FF8A00] text-white',
  danger: 'bg-[#FDECEC] text-[#C62828]',
  violet: 'bg-violet text-white',
}

/** Unread badge (14px, #346EF3) and role chips (Manager / Owner). */
const Badge = ({ className, tone = 'brand', size = 'xs', ...props }: Props) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center justify-center font-medium leading-none tracking-[-0.2px]',
      size === 'xs'
        ? 'h-[14px] min-w-[14px] rounded-full px-1 text-[11px]'
        : 'h-5 rounded-[6px] px-2 text-[12px]',
      TONE[tone],
      className
    )}
    {...props}
  />
)

export default Badge
